module.exports = __webpack_public_path__ + "static/media/pixel mall shot 02.5f19b7d7.webp";